export const SubtractIcon = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '16'}
    height={height || '16'}
    viewBox={viewBox || '0 0 16 16'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.75 4.75C8.75 4.33579 8.41421 4 8 4C7.58579 4 7.25 4.33579 7.25 4.75V9.3401L5.29959 7.23966C5.01774 6.93613 4.54319 6.91855 4.23966 7.20041C3.93613 7.48226 3.91855 7.95681 4.20041 8.26034L7.45041 11.7603C7.59231 11.9132 7.79145 12 8 12C8.20855 12 8.40769 11.9132 8.54959 11.7603L11.7996 8.26034C12.0814 7.95681 12.0639 7.48226 11.7603 7.20041C11.4568 6.91855 10.9823 6.93613 10.7004 7.23966L8.75 9.3401V4.75Z"
      fill={fill || 'white'}
    />
  </svg>
);
